// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueI18n from 'vue-i18n'
import vMediaQuery from 'v-media-query'
import VueResource from 'vue-resource'
import VueCharts from 'vue-charts'
import 'innersvg-polyfill'
import '../static/css/bootstrap.min.css'

import Icon from 'vue-riva-style/icons/glyphicon'

import traduzioni from './assets/Traduzioni'
import 'es6-promise/auto'
import Vuex from 'vuex'
import store from './components/Store'

Vue.use(Vuex)

Vue.component('icon', Icon)

Vue.use(VueResource)
Vue.use(vMediaQuery)
Vue.use(VueCharts)

Vue.config.productionTip = false

Vue.use(VueI18n)

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: sessionStorage.getItem('codLang'), // set locale
  fallbackLocale: 'it_IT', // default lang
  messages: traduzioni,
  silentTranslationWarn: true
})

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

Vue.http.interceptors.push((request, next) => {
  let makeID = (request.url.indexOf('?') > 0 ? '&markReqID=' + makeid() : '?markReqID=' + makeid())

  let arrayUrlPortale = [
    'portale',
    'noauth'
  ]
  let arrayUrlAcquisti = [
    'dashboardacq',
    'richiestediquotazione',
    'richiestediofferta',
    'situazioneordini'
  ]
  let arrayUrlAccessoStabilimenti = [
    'accessostabilimenti',
    'dashboardaccstab',
    'contestazioni',
    'anagraficadipendenti',
    'associadipendenti',
    'documentirichiesti'
  ]
  let arrayUrlRottame = [
    'buonidiscarico',
    'storicorottame',
    'dashboardrot'
  ]
  let arrayDownload = [
    'http://localhost:8081/',
    'https://webq.rivagroup.com/PortaleFornitori-Acquisti/',
    'https://web.rivagroup.com/PortaleFornitori-Acquisti/',
    'http://localhost:8083/',
    'https://webq.rivagroup.com/PortaleFornitori-Rottame/',
    'https://web.rivagroup.com/PortaleFornitori-Rottame/'
  ]
  if (arrayUrlPortale.some(el => request.url.includes(el))) {
    request.url = process.env.baseUrlSpringPortale + request.url + makeID
  } else if (arrayUrlAcquisti.some(el => request.url.includes(el))) {
    request.url = process.env.baseUrlSpringAcquisti + request.url + makeID
  } else if (arrayUrlAccessoStabilimenti.some(el => request.url.includes(el))) {
    request.url = process.env.baseUrlSpringAccessoStabilimenti + request.url + makeID
  } else if (arrayUrlRottame.some(el => request.url.includes(el))) {
    request.url = process.env.baseUrlSpringRottame + request.url + makeID
  } else {
    if (!arrayDownload.some(el => request.url.includes(el))) {
      request.url = process.env.baseUrl + request.url + makeID
    } else {
      request.url = request.url + makeID
    }
  }

  // console.log('request.url:' + request.url)
  let EXCLUDED_PATH = ['registrazione', 'recovery', 'support']
  // request.headers.set('Authorization', token)
  request.headers.map.Authorization = ['Bearer ' + sessionStorage.getItem('token')]
  // request.headers.map.Authorization = ['Bearer ' + token]
  next(function (response) {
    // modify response
    if (response.status === 401 || response.status === 403) {
      if (EXCLUDED_PATH.indexOf(this.$route.name) === -1) {
        this.$router.push({ name: 'Login' })
      }
    }
  })
})

function makeid() {
  for (var e = '', n = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789', i = 0; i < 5; i++) {
    e += n.charAt(Math.floor(Math.random() * n.length))
  }
  return e
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  i18n,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js